class CountryService {
  constructor (http) {
    this.http = http
  }

  async getCountries () {
    const result = await this.http.get('/countries')
    return result.data
  }

  async getCities (countryId) {
    const result = await this.http.get(`/countries/${countryId}/cities`)
    return result.data
  }

  async getTerminals (countryId, transportMode) {
    const result = await this.http.get(`/countries/${countryId}/terminals?transportMode=${transportMode}`)
    return result.data
  }
}
export default CountryService
